import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from "react-router-dom";
import './index.css';
import App from './App';
import { API_KEY } from './Utils/Constants';
import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import i18nHttpApi from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

i18next
  .use(initReactI18next)
  .use(i18nHttpApi)
  .use(LanguageDetector)
  .init({
    react: { useSuspense: false },
    defaultLocale: 'en',
    fallbackLng: "en",
    load: 'languageOnly',
    backend: {
      loadPath: '/api/locales/{{lng}}',
      queryStringParams: { key: API_KEY }
    }
  });

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById('root')
);